import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-reassign',
  templateUrl: './reassign.component.html',
  styleUrls: ['./reassign.component.scss']
})
export class ReassignComponent implements OnInit {

  apptDetails: any;
  userRole: any;
  apptId: any;
  AppointmentForm!: FormGroup;
  diagAvailable: boolean = true;
  locations: any;
  diagList:any;
  diagId: any = '';
  locationId: any = '';
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private appointmentService: AppointmentService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.diagAvailable = false;
    this.userRole = this.auth.getUserType()
    this.activatedRoute.params.subscribe(params => {
      this.apptId = params['id']
    });
    this.appointmentService.getLocations()
    .subscribe(requestTwo => {
      this.locations = requestTwo;

    });
    this.AppointmentForm = this.formBuilder.group({
      locationId: [''],
      appointmentId: [''],
      diagnosticianId: ['', Validators.required],
    });
    this.appointmentService.getAppointments(null, null, null, this.apptId, null, null).subscribe(data=>{
      this.apptDetails = data.data[0];
      this.locationId = this.apptDetails.appointmentDetails.locationId;
      this.diagId = this.apptDetails.appointmentDetails.diagnosticianId;
      //this.resourceName = this.apptDetails.appointmentDetails.diagnosticianName;
     // this.locationName = this.apptDetails.appointmentDetails.location;
     // this.scheduleId = this.apptDetails.appointmentDetails.schedules[0].scheduleId;
     this.appointmentService.getUser(this.locationId, 1002).subscribe(user => {
      this.diagList= user.data;
        });
    });
  
   

    // forkJoin({
    //   user: this.appointmentService.getUser(null, 1003),
    //   director: this.appointmentService.getUser(null, 1004),

    // }).subscribe(({ user, director }) => {
    //   user.data.forEach((admin: any) => {
    //     this.UserDaigAdmin.push(admin);
    //   });

    //   director.data.forEach((dir: any) => {

    //     this.UserDaigAdmin.push(dir);
    //   });
    // });

  

  }
  selectLocation() {

   this.appointmentService.getUser(this.locationId, 1002).subscribe(user => {
    if(user.data.length>0){
      this.diagAvailable = false;
    this.diagList= user.data;
    }else{
      this.diagList= null;
      this.diagId=null;
      this.diagAvailable = true;
      // this.AppointmentForm.controls['diagnosticianId'].setValidators([Validators.required]);
      // this.AppointmentForm.controls['diagnosticianId'].touched;
      // this.AppointmentForm.controls['diagnosticianId'].errors;
      // this.AppointmentForm.controls['diagnosticianId'].updateValueAndValidity();
      
    }
  
       
      });
  }
  selectDiag(){
    this.AppointmentForm.controls['diagnosticianId'].setValue(this.diagId);

  }
  submitForm() {
    this.spinner.show();
    this.AppointmentForm.controls['appointmentId'].setValue(
      this.apptId
    );
    this.AppointmentForm.controls['locationId'].setValue(this.locationId);
    this.AppointmentForm.controls['diagnosticianId'].setValue(this.diagId);
    
    this.appointmentService
      .reassignAppointmentMethod(this.AppointmentForm.value)
      .subscribe(
        (res: any) => {
         // console.log(res);
          if (res.code == '500') {
            this.spinner.hide();
            return;
          }
          this.spinner.hide();
          this.router.navigate(['/appt-all-details',this.apptId]);
          // jQuery('#paymentModal').modal('show');
          // this.testAmount = res.data.totalAmount;
          // this.clientId = res.data.clientId;
          // this.appointmentId = res.data.appointmentId;
        },
        (err) => {
          this.spinner.hide();
  
        }
      );
  }


}
